export const GTM_IDS = {
  Button_WeekView: 'Button_WeekView',
  Button_Today: 'Button_Today',
  Button_DayView: 'Button_DayView',
  Button_NextVisiblePeriod: 'Button_NextVisiblePeriod',
  PreviousVisiblePeriod: 'PreviousVisiblePeriod',

  Button_SendDirectSpeech: 'Button_SendDirectSpeech',
  Button_PreviewDirectSpeech: 'Button_PreviewDirectSpeech',
  
  Button_HamburgerMenu: 'Button_HamburgerMenu',
  Button_SelectTessa: 'Button_SelectTessa',
  Button_Logout: 'Button_Logout',
  Button_AddMenu: 'Button_AddMenu',
  Button_NewInteraction: 'Button_NewInteraction',
  Button_Info: 'Button_Info',
  Button_ToggleSpeechInteraction: 'Button_ToggleSpeechInteraction',
  Button_NewScript: 'Button_NewScript',
  Button_NewScriptSave: 'Button_NewScriptSave',
  Button_NewScriptCancel: 'Button_NewScriptCancel',

  Button_SearchScript: 'Button_SearchScript',

  VisitsAndActivities: 'VisitsAndActivities',
  FoodAndDrinks: 'FoodAndDrinks',
  PersonalHygiene: 'PersonalHygiene',
  Health: 'Health',
  Household: 'Household',
  Other: 'Other',

  Button_EditScriptSubMenu: 'Button_EditScriptSubMenu',
  Button_EditScript: 'Button_EditScript',
  Button_DeleteScript: 'Button_DeleteScript',

  Button_EditScriptTaskOverview:'Button_EditScriptTaskOverview',
  Button_EditScriptSchedule: 'Button_EditScriptSchedule',
  Button_EditScriptRecurring: 'Button_EditScriptRecurring',

  Select_MusicPlaylist: 'Select_MusicPlaylist',
  Button_EditMusicSubMenu: 'Button_EditMusicSubMenu',
  Button_DeleteMusicList: 'Button_DeleteMusicList',

  Button_EditMusicPlaylist: 'Button_EditMusicPlaylist',
  Button_EditMusicSchedule: 'Button_EditMusicSchedule',
  Button_EditMusicRecurring: 'Button_EditMusicRecurring'


} as const;


export type GtmId = typeof GTM_IDS[keyof typeof GTM_IDS];

export const gtmIdValues = Object.values(GTM_IDS);

const toCamelCase = (templateGroup: string) => {
  return templateGroup
    ?.toLowerCase()
    ?.replace(/[^a-zA-Z0-9 ]/g, '')
    ?.split(' ')
    ?.map((word, index) => {
      if (index === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join('');
}

export const getGtmScriptCategoryId = (
  category: string,
  templateGroup: string
): string | undefined => {
  const templateName = toCamelCase(templateGroup)

  switch (category) {
    case 'act_visits':
      return `button_${templateName}${GTM_IDS.VisitsAndActivities}`
    case 'sustenance':
      return `button_${templateName}${GTM_IDS.FoodAndDrinks}`
    case 'selfcare':
      return `button_${templateName}${GTM_IDS.PersonalHygiene}`
    case 'health':
      return `button_${templateName}${GTM_IDS.Health}`
    case 'household':
      return `button_${templateName}${GTM_IDS.Household}`
    case 'other':
      return `button_${templateName}${GTM_IDS.Other}`
    default:
      return undefined;
  }
};

export const getGtmScriptFolderId = (templateGroup: string)  => {
  const templateName = toCamelCase(templateGroup)
  return templateName ? `button_${templateName}Folder`: undefined
}

export const getGtmScriptSubMenuId = (
  type: string,
): GtmId | undefined => {

  switch (type) {
    case 'delete':
      return GTM_IDS.Button_DeleteScript;

    case 'edit':
      return GTM_IDS.Button_EditScript;

    default:
      return undefined;
  }
};
